import api from '../../helpers/axios'

export const state = {
    level: null,
    levels: []
};

export const getters = {
    level: (state) => state.level,
    levels: (state) => state.levels,
};

export const mutations = {
    setLevel(state, newValue) {
        state.level = newValue;
    },
    setLevels(state, newValue) {
        state.level = newValue;
    },
};

export const actions = {
   createLevel(_,  data) {
        return new Promise((resolve,reject) => {
            api.post("/levels", data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
  updateLevel(_, { id, data }) {
        return new Promise((resolve, reject) => {
            api.put("/levels/" + id, data).then((res) => {
                resolve(res.data.data);
            }).catch((err) => {
                reject(err);
            });
        });
    },
    deleteLevel(_, id) {
        return new Promise((resolve) => {
            api.delete("/levels/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },

    fetchLevel({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/levels/"+id).then((res) => {
                commit("setLevel", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
   fetchLevels({ commit }, { name, page, limit, listType }) {
        let query = "?";
       if (name) {
           query += `name=${name}&`;
       }
        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

        return new Promise((resolve) => {
            api.get("/levels" + query).then((res) => {
                commit("setLevels", res.data.data);
                resolve(res.data.data);
            });
        });
    },

};
